import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ImageZoomDirective } from '@app/components/zoom/image-zoom-directive/image-zoom.directive';
import { XMLElementBaseComponent } from '../base';
import { Image } from '../volkswagen.types';
import { environment } from '@env';

@Component({
  selector: 'app-vw-image',
  imports: [ImageZoomDirective, CommonModule],
  standalone: true,
  template: `
    <div class="my-3 px-1" appImageZoom>
      <img [src]="getImageUrl()" [alt]="provider + ' Image: ' + data.name" class="h-auto max-h-[60dvh] max-w-full border border-gray-300" />
    </div>
  `,
})
export class ImageComponent extends XMLElementBaseComponent<Image> {
  protected readonly environment = environment;

  getImageUrl(): string {
    const baseUrl = this.environment.api.url;
    const params = `subject=RL&vehicleId=${this.data.vehicleId}&imageId=${this.data.name}`;

    switch (this.provider) {
      case 'volkswagen':
        return `${baseUrl}/rmi/vw/proxy-image?${params}`;
      case 'skoda':
        return `${baseUrl}/rmi/skoda/proxy-image?${params}`;
      case 'seat':
        return `${baseUrl}/rmi/seat/proxy-image?${params}`;
      case 'audi':
        return `${baseUrl}/rmi/audi/proxy-image?${params}`;
      default:
        //console.warn('⚠️ Unknown provider, using default:', this.provider);
        return `${baseUrl}/rmi/proxy-image?${params}`;
    }
  }
}
